// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   Row,
//   Col,
//   Radio,
//   Input,
//   DatePicker,
//   InputNumber,
//   Button,
//   Tag,
//   Form,
// } from "antd";

// import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
// import dayjs from "dayjs";

// function GovtLandForm({ form, stepKey,tracking }) {
//   const [additionalNocs, setAdditionalNocs] = useState([]);
//     const sectionDateMap = {
//         govt_1: tracking?.section1_planned_date,
//         govt_2: tracking?.section2_planned_date,
//         govt_3: tracking?.section3_planned_date,
//         govt_4: tracking?.section4_planned_date,
//         govt_5: tracking?.section5_planned_date,
//     };

//     const renderSectionTitle = (title) => (
//         <div
//             style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//             }}
//         >
//             <span>{title}</span>

//             {sectionDateMap[stepKey] && (
//                 <Tag color="blue">
//                     Planned:{" "}
//                     {dayjs(sectionDateMap[stepKey]).format(
//                         "DD MMM YYYY"
//                     )}
//                 </Tag>
//             )}
//         </div>
//     );
//   // Auto-populate additional NOCs from API data
//   useEffect(() => {
//     if (stepKey === "govt_3") {
//       const fields = form.getFieldsValue(true);
//       const existingSlots = [];
//       for (let i = 1; i <= 4; i++) {
//         if (fields[`any_other_noc_slot_${i}_name`] || fields[`any_other_noc_slot_${i}_status`]) {
//           existingSlots.push({ id: Date.now() + i });
//         }
//       }
//       if (existingSlots.length > 0) {
//         setAdditionalNocs(existingSlots);
//       }
//     }
//   }, [form, stepKey]);

//   const handleAddNoc = () => {
//     if (additionalNocs.length >= 4) return;
//     setAdditionalNocs([...additionalNocs, { id: Date.now() }]);
//   };

//   const handleRemoveNoc = (id) =>
//     setAdditionalNocs(additionalNocs.filter((n) => n.id !== id));

//   // ── STEP 1: Land Bank & Feasibility ──────────────────────────────────────
//   if (stepKey === "govt_1") {
//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("LAND BANK IDENTIFICATION & FEASIBILITY")}>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Land bank received from Talathi / Tahsildar</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item name="land_bank_received_from_talathi_tahsildar_status" label="Status">
//                   <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="land_bank_received_from_talathi_tahsildar_date_planned" label="Date Planned">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="land_bank_received_from_talathi_tahsildar_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={8}>
//                 <Form.Item name="land_bank_received_from_talathi_tahsildar_remarks" label="Remarks">
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Details of Feasible Land - Matching your image layout */}
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Details of Feasible Land</h4>
//             <Row gutter={[16, 16]}>
//               <Col xs={24} md={12}>
//                 <Form.Item name="surveyno_gutno_details" label="Survey No / Gut No">
//                   <Input />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={12}>
//                 <Form.Item name="mouje_details" label="Mouje">
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>
//             <Form.Item name="survey_no_gut_no_details_mapped_out_remarks" label="Remarks">
//               <Input.TextArea rows={3} />
//             </Form.Item>
//           </Card>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">
//               No. of land identified
//             </h4>

//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item
//                   name="no_of_land_identified_status"
//                   label="Count"
//                 >
//                   <InputNumber
//                     min={0}
//                     style={{ width: "100%" }}
//                   />
//                 </Form.Item>
//               </Col>

//               <Col xs={24} md={5}>
//                 <Form.Item
//                   name="no_of_land_identified_date_actual"
//                   label="Date Actual"
//                 >
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>

//               <Col xs={24} md={13}>
//                 <Form.Item
//                   name="no_of_land_identified_remarks"
//                   label="Remarks"
//                 >
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Feasibility ascertainment done (Electrical)</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item name="feasibility_ascertainment_done_electrical_status" label="Status">
//                   <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="feasibility_ascertainment_done_electrical_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={13}>
//                 <Form.Item name="feasibility_ascertainment_done_electrical_remarks" label="Remarks">
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Feasibility ascertainment done (Civil)</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item name="feasibility_ascertainment_done_civil_status" label="Status">
//                   <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="feasibility_ascertainment_done_civil_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={13}>
//                 <Form.Item name="feasibility_ascertainment_done_civil_remarks" label="Remarks">
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Most feasible land identified</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item name="most_feasible_land_identified_status" label="Status">
//                   <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="most_feasible_land_identified_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={13}>
//                 <Form.Item name="most_feasible_land_identified_remarks" label="Remarks">
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Area & Distance - Only fields available in API */}
//         <Card className="tracking-item-card">
//           <h4 className="tracking-question-label">Land Details</h4>

//           <Row gutter={[16, 16]}>
//             <Col xs={24} md={6}>
//               <Form.Item
//                 name="area_of_feasible_land_ha_r_area"
//                 label="Area of Feasible Land (Ha/R)"
//               >
//                 <Input />
//               </Form.Item>
//             </Col>

//             <Col xs={24} md={6}>
//               <Form.Item
//                 name="distance_from_load_centre_km_distance"
//                 label="Distance from Load Centre (km)"
//               >
//                 <Input />
//               </Form.Item>
//             </Col>

//             <Col xs={24} md={12}>
//               <Form.Item
//                 name="area_of_feasible_land_ha_r_remarks"
//                 label="Remarks"
//               >
//                 <Input.TextArea rows={2} />
//               </Form.Item>
//             </Col>
//           </Row>
//         </Card>
//         </Card>
//       </Form>
//     );
//   }

//   // ── STEP 2: Proposal Routing ───────────────────────────────────────────────
//   if (stepKey === "govt_2") {
//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("PROPOSAL ROUTING")}>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">LA proposal to Tehsildar</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item name="la_proposal_to_tehsildar_status" label="Status">
//                   <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="la_proposal_to_tehsildar_date_planned" label="Date Planned">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="la_proposal_to_tehsildar_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={8}>
//                 <Form.Item name="la_proposal_to_tehsildar_remarks" label="Remarks">
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Whether Tahsildar issued letter for NOC</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item name="whether_tasildar_issued_letter_for_noc_to_relevant_dept_status" label="Status">
//                   <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="whether_tasildar_issued_letter_for_noc_to_relevant_dept_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={13}>
//                 <Form.Item name="whether_tasildar_issued_letter_for_noc_to_relevant_dept_remarks" label="Remarks">
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Tahsildar Name</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={8}>
//                 <Form.Item name="tahsildar_name_name" label="Name">
//                   <Input />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={16}>
//                 <Form.Item name="tahsildar_name_remarks" label="Remarks">
//                   <Input.TextArea rows={2} />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>
//         </Card>
//       </Form>
//     );
//   }

//   // ── STEP 3: NOC & Clearances ───────────────────────────────────────────────
//   if (stepKey === "govt_3") {
//     const nocRows = [
//       ["Forest NOC", "forest_noc_status", "forest_noc_date_planned", "forest_noc_date_actual", "forest_noc_remarks"],
//       ["ZP NOC", "zp_noc_status", "zp_noc_date_planned", "zp_noc_date_actual", "zp_noc_remarks"],
//       ["PWD NOC", "pwd_noc_status", "pwd_noc_date_planned", "pwd_noc_date_actual", "pwd_noc_remarks"],
//       ["Town Planning NOC", "town_planning_noc_status", "town_planning_noc_date_planned", "town_planning_noc_date_actual", "town_planning_noc_remarks"],
//       ["Irrigation NOC", "irrigation_noc_status", "irrigation_noc_date_planned", "irrigation_noc_date_actual", "irrigation_noc_remarks"],
//       ["Town Planning Valuation", "town_planning_valuation_status", "town_planning_valuation_date_planned", "town_planning_valuation_date_actual", "town_planning_valuation_remarks"],
//       ["Gram Panchayat Thaarav", "gram_panchayat_thaarav_status", "gram_panchayat_thaarav_date_planned", "gram_panchayat_thaarav_date_actual", "gram_panchayat_thaarav_remarks"],
//     ];

//     const slotNames = ["any_other_noc_slot_1", "any_other_noc_slot_2", "any_other_noc_slot_3", "any_other_noc_slot_4"];

//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("NOC & CLEARANCES")}>
//           {nocRows.map(([title, statusName, plannedName, actualName, remarksName]) => (
//             <Card key={statusName} className="tracking-item-card">
//               <h4 className="tracking-question-label">{title}</h4>
//               <Row gutter={[16, 12]}>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={statusName} label="Status">
//                     <Radio.Group>
//                       <Radio value="YES">Yes</Radio>
//                       <Radio value="NO">No</Radio>
//                       <Radio value="NA">N/A</Radio>
//                     </Radio.Group>
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={plannedName} label="Date Planned">
//                     <DatePicker style={{ width: "100%" }} />
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={actualName} label="Date Actual">
//                     <DatePicker style={{ width: "100%" }} />
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={9}>
//                   <Form.Item name={remarksName} label="Remarks">
//                     <Input.TextArea rows={2} />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </Card>
//           ))}

//           {/* Additional NOCs - Hidden until added */}
//           {additionalNocs.map((noc, index) => (
//             <Card key={noc.id} className="tracking-item-card">
//               <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
//                 <h4 className="tracking-question-label">Additional NOC {index + 1}</h4>
//                 <Button danger size="small" icon={<DeleteOutlined />} onClick={() => handleRemoveNoc(noc.id)} />
//               </div>
//               <Row gutter={[16, 12]}>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={`${slotNames[index]}_name`} label="NOC Name">
//                     <Input />
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={`${slotNames[index]}_status`} label="Status">
//                     <Radio.Group>
//                       <Radio value="YES">Yes</Radio>
//                       <Radio value="NO">No</Radio>
//                       <Radio value="NA">N/A</Radio>
//                     </Radio.Group>
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={`${slotNames[index]}_date_actual`} label="Date Actual">
//                     <DatePicker style={{ width: "100%" }} />
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={9}>
//                   <Form.Item name={`${slotNames[index]}_remarks`} label="Remarks">
//                     <Input.TextArea rows={2} />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </Card>
//           ))}

//           <Button type="dashed" icon={<PlusOutlined />} onClick={handleAddNoc} disabled={additionalNocs.length >= 4} block>
//             Add Additional NOC
//           </Button>
//         </Card>
//       </Form>
//     );
//   }

//   // ── STEP 4: Joint Measurement ─────────────────────────────────────────────
//   if (stepKey === "govt_4") {
//     const jmRows = [
//       ["Final report from Tahsildar to Collector", "final_report_form_tahsildar_to_collector_status", "final_report_form_tahsildar_to_collector_date_actual", "final_report_form_tahsildar_to_collector_remarks"],
//       ["Letter from Collector to Dy. SLR for JM", "letter_from_collector_to_dy_slr_for_jm_status", "letter_from_collector_to_dy_slr_for_jm_date_actual", "letter_from_collector_to_dy_slr_for_jm_remarks"],
//       ["JM Payment Demand Received", "jm_payment_demand_received_status", "jm_payment_demand_received_date_actual", "jm_payment_demand_received_remarks"],
//       ["Payment of JM done", "payment_of_jm_done_status", "payment_of_jm_done_date_actual", "payment_of_jm_done_remarks"],
//       ["JM carried out", "jm_carried_out_status", "jm_carried_out_date_actual", "jm_carried_out_remarks"],
//       ["JM plan received", "jm_plan_received_status", "jm_plan_received_date_actual", "jm_plan_received_remarks"],
//     ];

//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("JOINT MEASUREMENT & PAYMENT")}>
//           {jmRows.map(([label, statusName, dateName, remarksName]) => (
//             <Card key={statusName} className="tracking-item-card">
//               <h4 className="tracking-question-label">{label}</h4>
//               <Row gutter={[16, 12]}>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={statusName} label="Status">
//                     <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={dateName} label="Date Actual">
//                     <DatePicker style={{ width: "100%" }} />
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={14}>
//                   <Form.Item name={remarksName} label="Remarks">
//                     <Input.TextArea rows={2} />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </Card>
//           ))}
//         </Card>
//       </Form>
//     );
//   }

//   // ── STEP 5: Possession & Handover ─────────────────────────────────────────
//   if (stepKey === "govt_5") {
//     const rows = [
//       ["Advance Possession Order", "advance_possession_order_status", null, "advance_possession_order_date_actual", "advance_possession_order_remarks"],
//       ["Final Order Received", "final_order_received_status", null, "final_order_received_date_actual", "final_order_received_remarks"],
//       ["Handing Over Done", "handing_over_done_status", null, "handing_over_done_date_actual", "handing_over_done_remarks"],
//       ["Joint Verification & Possession Receipt", "joint_verification_possession_receipt_status", null, "joint_verification_possession_receipt_date_actual", "joint_verification_possession_receipt_remarks"],
//     ];

//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("POSSESSION & TAKING OVER")}>
//           {rows.map(([label, statusName, plannedName, receivingName, remarksName]) => (
//             <Card key={statusName} className="tracking-item-card">
//               <h4 className="tracking-question-label">{label}</h4>
//               <Row gutter={[16, 12]}>
//                 <Col xs={24} md={5}>
//                   <Form.Item name={statusName} label="Status">
//                     <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
//                   </Form.Item>
//                 </Col>
//                 {plannedName && (
//                   <Col xs={24} md={5}>
//                     <Form.Item name={plannedName} label="Date Planned">
//                       <DatePicker style={{ width: "100%" }} />
//                     </Form.Item>
//                   </Col>
//                 )}
//                 <Col xs={24} md={5}>
//                   <Form.Item name={receivingName} label="Date Actual">
//                     <DatePicker style={{ width: "100%" }} />
//                   </Form.Item>
//                 </Col>
//                 <Col xs={24} md={9}>
//                   <Form.Item name={remarksName} label="Remarks">
//                     <Input.TextArea rows={2} />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </Card>
//           ))}
//         </Card>
//       </Form>
//     );
//   }

//   return null;
// }

// export default GovtLandForm;

import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Radio,
  Input,
  DatePicker,
  InputNumber,
  Button,
  Tag,
  Form,
} from "antd";

import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

function GovtLandForm({ form, stepKey, tracking }) {
  const [additionalNocs, setAdditionalNocs] = useState([]);
  const sectionDateMap = {
    govt_1: tracking?.section1_planned_date,
    govt_2: tracking?.section2_planned_date,
    govt_3: tracking?.section3_planned_date,
    govt_4: tracking?.section4_planned_date,
    govt_5: tracking?.section5_planned_date,
  };

  const renderSectionTitle = (title) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <span>{title}</span>
      {sectionDateMap[stepKey] && (
        <Tag color="blue">
          Planned: {dayjs(sectionDateMap[stepKey]).format("DD MMM YYYY")}
        </Tag>
      )}
    </div>
  );

  // slot field names, matching the API exactly: any_other_noc_(slot_N)_*
  const slotField = (i, suffix) => `any_other_noc_(slot_${i})_${suffix}`;

  // Auto-populate additional NOC rows from whatever's already in the form
  useEffect(() => {
    if (stepKey === "govt_3") {
      const fields = form.getFieldsValue(true);
      const existingSlots = [];
      for (let i = 1; i <= 4; i++) {
        if (fields[slotField(i, "name")] || fields[slotField(i, "status")]) {
          existingSlots.push({ id: i });
        }
      }
      if (existingSlots.length > 0) setAdditionalNocs(existingSlots);
    }
  }, [form, stepKey]);

  const handleAddNoc = () => {
    if (additionalNocs.length >= 4) return;
    const nextSlot = additionalNocs.length + 1;
    setAdditionalNocs([...additionalNocs, { id: nextSlot }]);
  };

  const handleRemoveNoc = (id) =>
    setAdditionalNocs(additionalNocs.filter((n) => n.id !== id));

  // ── STEP 1: Land Bank & Feasibility ──────────────────────────────────────
  if (stepKey === "govt_1") {
    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("LAND BANK IDENTIFICATION & FEASIBILITY")}>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Land bank received from Talathi / Tahsildar</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="land_bank_received_from_talathi_tahsildar_status" label="Status">
                  <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="land_bank_received_from_talathi_tahsildar_date_planned" label="Date Planned">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="land_bank_received_from_talathi_tahsildar_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="land_bank_received_from_talathi_tahsildar_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Details of Feasible Land</h4>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Form.Item name="surveyno/gutno_details" label="Survey No / Gut No">
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="mouje_details" label="Mouje">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            {/* API stores one shared "remarks" value for this section - it
               may show the same text as the area/distance card below. */}
            <Form.Item name="details_of_feasible_land_remarks" label="Remarks">
              <Input.TextArea rows={3} />
            </Form.Item>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">No. of land identified</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="no_of_land_identified_status" label="Count">
                  <InputNumber min={0} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="no_of_land_identified_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={13}>
                <Form.Item name="no_of_land_identified_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Feasibility ascertainment done (Electrical)</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="feasibility_ascertainment_done_(electrical)_status" label="Status">
                  <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="feasibility_ascertainment_done_(electrical)_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={13}>
                <Form.Item name="feasibility_ascertainment_done_(electrical)_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Feasibility ascertainment done (Civil)</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="feasibility_ascertainment_done_(civil)_status" label="Status">
                  <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="feasibility_ascertainment_done_(civil)_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={13}>
                <Form.Item name="feasibility_ascertainment_done_(civil)_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Most feasible land identified</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="most_feasible_land_identified_status" label="Status">
                  <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="most_feasible_land_identified_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={13}>
                <Form.Item name="most_feasible_land_identified_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Land Details</h4>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Form.Item name="area_of_feasible_land_(ha/r)_area" label="Area of Feasible Land (Ha/R)">
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="distance_from_load_centre_(km)_distance" label="Distance from Load Centre (km)">
                  <Input />
                </Form.Item>
              </Col>
                  <Col xs={24} md={18}>
                    <Form.Item name="area_and_distance_remarks" label="Remarks">
                    <Input.TextArea rows={3} />
                  </Form.Item>
                  </Col>
            </Row>
          </Card>
        </Card>
      </Form>
    );
  }

  // ── STEP 2: Proposal Routing ───────────────────────────────────────────────
  if (stepKey === "govt_2") {
    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("PROPOSAL ROUTING")}>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">LA proposal to Tehsildar</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="la_proposal_to_tehsildar_status" label="Status">
                  <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="la_proposal_to_tehsildar_date_planned" label="Date Planned">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="la_proposal_to_tehsildar_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="la_proposal_to_tehsildar_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Whether Tahsildar issued letter for NOC</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="whether_tasildar_issued_letter_for_noc_to_relevant_dept_status" label="Status">
                  <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="whether_tasildar_issued_letter_for_noc_to_relevant_dept_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={13}>
                <Form.Item name="whether_tasildar_issued_letter_for_noc_to_relevant_dept_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Tahsildar Name</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={8}>
                <Form.Item name="tahsildar_name_name" label="Name">
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={16}>
                <Form.Item name="tahsildar_name_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Card>
      </Form>
    );
  }

  // ── STEP 3: NOC & Clearances ───────────────────────────────────────────────
  if (stepKey === "govt_3") {
    const nocRows = [
      ["Forest NOC", "forest_noc_status", "forest_noc_date_planned", "forest_noc_date_actual", "forest_noc_remarks"],
      ["ZP NOC", "zp_noc_status", "zp_noc_date_planned", "zp_noc_date_actual", "zp_noc_remarks"],
      ["PWD NOC", "pwd_noc_status", "pwd_noc_date_planned", "pwd_noc_date_actual", "pwd_noc_remarks"],
      ["Town Planning NOC", "town_planning_noc_status", "town_planning_noc_date_planned", "town_planning_noc_date_actual", "town_planning_noc_remarks"],
      ["Irrigation NOC", "irrigation_noc_status", "irrigation_noc_date_planned", "irrigation_noc_date_actual", "irrigation_noc_remarks"],
      ["Town Planning Valuation", "town_planning_valuation_status", "town_planning_valuation_date_planned", "town_planning_valuation_date_actual", "town_planning_valuation_remarks"],
      ["Gram Panchayat Thaarav", "gram_panchayat_thaarav_status", "gram_panchayat_thaarav_date_planned", "gram_panchayat_thaarav_date_actual", "gram_panchayat_thaarav_remarks"],
    ];

    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("NOC & CLEARANCES")}>
          {nocRows.map(([title, statusName, plannedName, actualName, remarksName]) => (
            <Card key={statusName} className="tracking-item-card">
              <h4 className="tracking-question-label">{title}</h4>
              <Row gutter={[16, 12]}>
                <Col xs={24} md={5}>
                  <Form.Item name={statusName} label="Status">
                    <Radio.Group>
                      <Radio value="YES">Yes</Radio>
                      <Radio value="NO">No</Radio>
                      <Radio value="NA">N/A</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <Form.Item name={plannedName} label="Date Planned">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <Form.Item name={actualName} label="Date Actual">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={9}>
                  <Form.Item name={remarksName} label="Remarks">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          ))}

          {/* Additional NOCs - Hidden until added */}
          {additionalNocs.map((noc, index) => (
            <Card key={noc.id} className="tracking-item-card">
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
                <h4 className="tracking-question-label">Additional NOC {index + 1}</h4>
                <Button danger size="small" icon={<DeleteOutlined />} onClick={() => handleRemoveNoc(noc.id)} />
              </div>
              <Row gutter={[16, 12]}>
                <Col xs={24} md={5}>
                  <Form.Item name={slotField(noc.id, "name")} label="NOC Name">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item name={slotField(noc.id, "status")} label="Status">
                    <Radio.Group>
                      <Radio value="YES">Yes</Radio>
                      <Radio value="NO">No</Radio>
                      <Radio value="NA">N/A</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <Form.Item name={slotField(noc.id, "date_planned")} label="Date Planned">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <Form.Item name={slotField(noc.id, "date_actual")} label="Date Actual">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <Form.Item name={slotField(noc.id, "remarks")} label="Remarks">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          ))}

          <Button type="dashed" icon={<PlusOutlined />} onClick={handleAddNoc} disabled={additionalNocs.length >= 4} block>
            Add Additional NOC
          </Button>
        </Card>
      </Form>
    );
  }

  // ── STEP 4: Joint Measurement ─────────────────────────────────────────────
  if (stepKey === "govt_4") {
    const jmRows = [
      ["Final report from Tahsildar to Collector", "final_report_form_tahsildar_to_collector_status", "final_report_form_tahsildar_to_collector_date_actual", "final_report_form_tahsildar_to_collector_remarks"],
      ["Letter from Collector to Dy. SLR for JM", "letter_from_collector_to_dy_slr_for_jm_status", "letter_from_collector_to_dy_slr_for_jm_date_actual", "letter_from_collector_to_dy_slr_for_jm_remarks"],
      ["JM Payment Demand Received", "jm_payment_demand_received_status", "jm_payment_demand_received_date_actual", "jm_payment_demand_received_remarks"],
      ["Payment of JM done", "payment_of_jm_done_status", "payment_of_jm_done_date_actual", "payment_of_jm_done_remarks"],
      ["JM carried out", "jm_carried_out_status", "jm_carried_out_date_actual", "jm_carried_out_remarks"],
      ["JM plan received", "jm_plan_received_status", "jm_plan_received_date_actual", "jm_plan_received_remarks"],
    ];

    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("JOINT MEASUREMENT & PAYMENT")}>
          {jmRows.map(([label, statusName, dateName, remarksName]) => (
            <Card key={statusName} className="tracking-item-card">
              <h4 className="tracking-question-label">{label}</h4>
              <Row gutter={[16, 12]}>
                <Col xs={24} md={5}>
                  <Form.Item name={statusName} label="Status">
                    <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <Form.Item name={dateName} label="Date Actual">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={14}>
                  <Form.Item name={remarksName} label="Remarks">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          ))}
        </Card>
      </Form>
    );
  }

  // ── STEP 5: Possession & Handover ─────────────────────────────────────────
  if (stepKey === "govt_5") {
    const rows = [
      ["Advance Possession Order", "advance_possession_order_status", "advance_possession_order_date_actual", "advance_possession_order_remarks"],
      ["Final Order Received", "final_order_received_status", "final_order_received_date_actual", "final_order_received_remarks"],
      ["Handing Over Done", "handing_over_done_status", "handing_over_done_date_actual", "handing_over_done_remarks"],
      ["Joint Verification & Possession Receipt", "joint_verification_possession_receipt_status", "joint_verification_possession_receipt_date_actual", "joint_verification_possession_receipt_remarks"],
    ];

    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("POSSESSION & TAKING OVER")}>
          {rows.map(([label, statusName, actualName, remarksName]) => (
            <Card key={statusName} className="tracking-item-card">
              <h4 className="tracking-question-label">{label}</h4>
              <Row gutter={[16, 12]}>
                <Col xs={24} md={5}>
                  <Form.Item name={statusName} label="Status">
                    <Radio.Group><Radio value="YES">Yes</Radio><Radio value="NO">No</Radio></Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <Form.Item name={actualName} label="Date Actual">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={14}>
                  <Form.Item name={remarksName} label="Remarks">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          ))}
        </Card>
      </Form>
    );
  }

  return null;
}

export default GovtLandForm;